import React, { FC } from 'react';
import { useTranslation } from 'hooks/use-translation';
import { ControlPanel } from '../control-panel';
import { AddUsers } from './add-users';
import { useTimesheetExcludedUsers } from './use-excluded-users';
import { useUserOptions } from './use-user-options';
import { ExcludedUserTable } from './user-table';

export const ExcludedUsersSettings: FC = () => {
  const label = useTranslation('settings.timesheets.controls.exclusion.label');
  const description = useTranslation(
    'settings.timesheets.controls.exclusion.description',
  );
  const excludedUsers = useTimesheetExcludedUsers();
  const [isUserOptionsLoading, userOptions] = useUserOptions();

  return (
    <ControlPanel label={label} descriptions={[description]}>
      <AddUsers
        data-cy="settings.timesheets.exclude"
        userOptions={userOptions}
        isUserOptionsLoading={isUserOptionsLoading}
        excludedUsers={excludedUsers}
      />
      <ExcludedUserTable
        excludedUsers={excludedUsers}
        allUserOptions={userOptions}
        isUserOptionsLoading={isUserOptionsLoading}
      />
    </ControlPanel>
  );
};
